(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["dtfg-o1-omni-editions"] && !Shopify.designMode) return;
  try {
    
(function(){
  function init(root){
    if(!root||root.__dtfe) return; root.__dtfe=true;
    var $$=function(s,c){return Array.prototype.slice.call((c||root).querySelectorAll(s));};
    var tabs=$$('[data-ed]'), panels=$$('[data-ed-panel]');
    var barName=root.querySelector('[data-bar-name]'), barPrice=root.querySelector('[data-bar-price]');
    var rank={starter:0,pro:1,plus:2};
    function active(){return panels.filter(function(p){return !p.hidden;})[0];}

    function applyBundle(panel,input){
      if(!input) return;
      var d=input.dataset;
      panel.querySelector('.dtfe-price').textContent=d.price;
      panel.querySelector('.dtfe-cmp').textContent=d.cmp||'';
      panel.querySelector('.dtfe-save').textContent=d.save?('Save '+d.save):'';
      panel.querySelector('.dtfe-form [name=id]').value=d.vid;
      var u=panel.querySelector('.dtfe-links [data-url]'); if(u&&d.url) u.href=d.url;
      var btn=panel.querySelector('[data-atc-btn]'); var ok=d.avail==='true';
      btn.disabled=!ok; btn.textContent=ok?(root.dataset.atcLabel||'Add to cart'):'Sold out';
      $$('[data-gal]',panel).forEach(function(g){g.hidden=g.dataset.gal!==input.value;});
      $$('.dtfe-x',panel).forEach(function(li){li.hidden=rank[d.tier]<rank[li.dataset.min];});
      if(panel===active()) barPrice.textContent=d.price;
    }
    function show(ed,push){
      var found=false;
      panels.forEach(function(p){var on=p.dataset.edPanel===ed;p.hidden=!on;if(on)found=true;});
      if(!found) return;
      tabs.forEach(function(t){t.setAttribute('aria-selected',t.dataset.ed===ed);});
      var p=active(); barName.textContent=p.dataset.edName;
      var c=p.querySelector('.dtfe-opt input:checked'); applyBundle(p,c);
      if(push&&history.replaceState) history.replaceState(null,'','#'+ed);
    }
    tabs.forEach(function(t){t.addEventListener('click',function(){show(t.dataset.ed,true);});});
    panels.forEach(function(p){
      $$('.dtfe-opt input',p).forEach(function(i){i.addEventListener('change',function(){applyBundle(p,i);});});
      applyBundle(p,p.querySelector('.dtfe-opt input:checked'));
      p.addEventListener('click',function(e){
        var th=e.target.closest('.dtfe-th'); if(!th) return;
        var gal=th.closest('[data-gal]'), img=gal.querySelector('.dtfe-main img');
        if(img){img.src=th.dataset.src;img.removeAttribute('srcset');}
        $$('.dtfe-th',gal).forEach(function(x){x.classList.toggle('on',x===th);});
      });
    });
    var h=(location.hash||'').replace('#','');
    show(['single','dual','fabric'].indexOf(h)>-1?h:(root.dataset.default||'dual'),false);

    $$('[data-go]').forEach(function(a){a.addEventListener('click',function(e){
      e.preventDefault(); var t=active().querySelector('[data-sec="'+a.dataset.go+'"]');
      if(t){var off=root.querySelector('[data-bar]').offsetHeight+10;window.scrollTo({top:t.getBoundingClientRect().top+window.pageYOffset-off,behavior:'smooth'});}
    });});
    root.querySelector('[data-bar-atc]').addEventListener('click',function(){
      var f=active().querySelector('[data-atc]'); if(!f) return;
      if(f.requestSubmit) f.requestSubmit(); else f.dispatchEvent(new Event('submit',{cancelable:true}));
    });

    var toast=root.querySelector('[data-toast]'), tt;
    $$('[data-atc]').forEach(function(f){
      f.addEventListener('submit',function(e){
        if(!window.fetch) return; e.preventDefault();
        var btn=f.querySelector('button'); if(btn.disabled) return; var txt=btn.textContent;
        btn.disabled=true; btn.textContent='Adding…';
        var r0=(window.Shopify&&Shopify.routes&&Shopify.routes.root)||'/';
        fetch(r0+'cart/add.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items:[{id:+f.querySelector('[name=id]').value,quantity:1}]})})
        .then(function(r){if(!r.ok) throw r; return r.json();})
        .then(function(){
          btn.textContent='Added ✓';
          toast.innerHTML=(root.dataset.atcLabel&&root.dataset.atcLabel!=='Add to cart'?'Presale reserved — added to your cart ':'Added to your cart ')+'<a href="'+r0+'cart">View cart →</a>';toast.classList.add('show');
          clearTimeout(tt);tt=setTimeout(function(){toast.classList.remove('show');},4500);
          document.dispatchEvent(new CustomEvent('cart:refresh',{bubbles:true}));
          setTimeout(function(){btn.disabled=false;btn.textContent=txt;},2200);
        }).catch(function(){f.submit();});
      });
    });
  }
  function boot(){document.querySelectorAll('.dtfe').forEach(init);}
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',boot); else boot();
  document.addEventListener('shopify:section:load',function(e){var r=e.target.querySelector('.dtfe');if(r)init(r);});
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dtfg-supplies"] && !Shopify.designMode) return;
  try {
    
(function(){
  function init(root){
    if(!root||root.__dtfs) return; root.__dtfs=true;
    var $$=function(s,c){return Array.prototype.slice.call((c||root).querySelectorAll(s));};
    var grid=root.querySelector('[data-grid]'), cards=$$('.dtfs-card');

    /* filter + sort */
    var chips=$$('.dtfs-chip');
    function filter(f){
      chips.forEach(function(c){c.setAttribute('aria-pressed',c.dataset.f===f);});
      cards.forEach(function(c){c.hidden=!(f==='all'||c.dataset.cat===f);});
    }
    chips.forEach(function(c){c.addEventListener('click',function(){filter(c.dataset.f);});});
    var sort=root.querySelector('[data-sort]');
    if(sort) sort.addEventListener('change',function(){
      var v=sort.value, arr=cards.slice();
      arr.sort(function(a,b){
        if(v==='price-asc') return a.dataset.price-b.dataset.price;
        if(v==='price-desc') return b.dataset.price-a.dataset.price;
        if(v==='az') return a.dataset.title.localeCompare(b.dataset.title);
        return a.dataset.idx-b.dataset.idx;
      });
      arr.forEach(function(c){grid.appendChild(c);});
    });
    $$('[data-jump]').forEach(function(a){a.addEventListener('click',function(){var ch=root.querySelector('.dtfs-chip[data-f="'+a.dataset.jump+'"]');filter(ch?a.dataset.jump:'all');});});

    /* qty */
    $$('.dtfs-qty').forEach(function(q){
      var inp=q.querySelector('input');
      $$('button',q).forEach(function(b){b.addEventListener('click',function(){inp.value=Math.max(1,(parseInt(inp.value)||1)+(+b.dataset.q));});});
    });

    /* kit builder */
    var kit=root.querySelector('[data-kit]'), data={};
    try{data=JSON.parse(root.querySelector('[data-kit-data]').textContent);}catch(e){}
    if(kit){
      var grade='eco', width='13', out=root.querySelector('[data-kit-out]');
      var q=function(s){return root.querySelector(s);};
      function avail(g,w){return !!data[g+'-'+w];}
      function render(){
        $$('.dtfs-opt',kit).forEach(function(b){b.setAttribute('aria-pressed',b.dataset.grade===grade);});
        $$('.dtfs-w',kit).forEach(function(b){b.disabled=!avail(grade,b.dataset.width);b.title=b.disabled?'Not available as a bundle for this ink grade':'';b.setAttribute('aria-pressed',b.dataset.width===width);});
        var d=data[grade+'-'+width];
        q('[data-kit-ink]').textContent='5 × 1L '+(grade==='eco'?'Eco':'Premium')+' inks — CMYK + White';
        q('[data-kit-film]').textContent=width+'" hot peel film roll';
        if(!d){out.classList.add('is-off');q('[data-kit-title]').textContent='This combination isn\'t available as a bundle';q('[data-kit-price]').textContent='';q('[data-kit-cmp]').textContent='';q('[data-kit-btn]').disabled=true;q('[data-kit-img]').innerHTML='';q('[data-kit-url]').style.display='none';return;}
        out.classList.remove('is-off');
        q('[data-kit-title]').textContent=d.title;
        q('[data-kit-price]').textContent=d.price;
        q('[data-kit-cmp]').textContent=d.cmp||'';
        q('[data-kit-vid]').value=d.vid;
        var btn=q('[data-kit-btn]'); btn.disabled=!d.avail; btn.textContent=d.avail?'Add kit to cart':'Sold out';
        q('[data-kit-img]').innerHTML=d.img?'<img src="'+d.img+'" alt="">':'';
        var u=q('[data-kit-url]'); u.href=d.url; u.style.display='';
      }
      function pickWidth(){ if(!avail(grade,width)){ var ws=['13','12','24']; for(var i=0;i<ws.length;i++){ if(avail(grade,ws[i])){width=ws[i];break;} } } }
      $$('.dtfs-opt',kit).forEach(function(b){b.addEventListener('click',function(){grade=b.dataset.grade;pickWidth();render();});});
      $$('.dtfs-w',kit).forEach(function(b){b.addEventListener('click',function(){width=b.dataset.width;render();});});
      $$('[data-pick]').forEach(function(a){a.addEventListener('click',function(){grade=a.dataset.pick;pickWidth();render();});});
      pickWidth(); render();
      if(!Object.keys(data).length) root.querySelector('#dtfs-kit').style.display='none';
    }

    /* add to cart */
    var toast=root.querySelector('[data-toast]'), tt;
    $$('[data-atc]').forEach(function(f){
      f.addEventListener('submit',function(e){
        if(!window.fetch) return; e.preventDefault();
        var btn=f.querySelector('button[type=submit]'); if(btn.disabled) return; var txt=btn.textContent;
        var qty=parseInt((f.querySelector('[name=quantity]')||{}).value)||1;
        btn.disabled=true; btn.textContent='Adding…';
        var r0=(window.Shopify&&Shopify.routes&&Shopify.routes.root)||'/';
        fetch(r0+'cart/add.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items:[{id:+f.querySelector('[name=id]').value,quantity:qty}]})})
        .then(function(r){if(!r.ok) throw r; return r.json();})
        .then(function(){
          btn.textContent='Added ✓';
          toast.innerHTML='Added to your cart <a href="'+r0+'cart">View cart →</a>';toast.classList.add('show');
          clearTimeout(tt);tt=setTimeout(function(){toast.classList.remove('show');},4500);
          document.dispatchEvent(new CustomEvent('cart:refresh',{bubbles:true}));
          setTimeout(function(){btn.disabled=false;btn.textContent=txt;},2200);
        }).catch(function(){f.submit();});
      });
    });
  }
  function boot(){document.querySelectorAll('.dtfs').forEach(init);}
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',boot); else boot();
  document.addEventListener('shopify:section:load',function(e){var r=e.target.querySelector('.dtfs');if(r)init(r);});
})();

  } catch(e) { console.error(e); }
})();
})();
